export default {
  AGROCOLOR: 'agrocolor',
  ECOLOGICO: 'ecologico',
  COPLACA: 'coplaca'
}